import { render, staticRenderFns } from "./padecimientosVista.vue?vue&type=template&id=13914523&scoped=true"
import script from "./padecimientosVista.vue?vue&type=script&lang=js"
export * from "./padecimientosVista.vue?vue&type=script&lang=js"
import style0 from "./padecimientosVista.vue?vue&type=style&index=0&id=13914523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13914523",
  null
  
)

export default component.exports